<template>
  <div>
    <v-row>
      <v-col cols="12" sm="10">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Search"
          single-line
          outlined
          rounded
          dense
          hide-details
        ></v-text-field> </v-col
      ><v-col cols="12" sm="2">
        <v-btn
          @click="goToNewDistrictAdmin"
          color="primary"
          small
          tile
          outlined
          ><v-icon small color="primary">mdi-plus</v-icon>
          New District Admin
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="districtAdmins"
      :search="search"
      :loading="loading"
      @click:row="(item) => goToDistrictAdmin(item)"
      style="cursor: pointer"
      class="alt-shading"
    ></v-data-table>
  </div>
</template>


<script>
export default {
  data() {
    return {
      headers: [
        {
          text: "Legacy Provider Id",
          value: "legacyProviderId",
          align: "left",
        },
        { text: "First Name", value: "firstName" },
        { text: "Last Name", value: "lastName" },
        { text: "Email Address", value: "emailAddress" },
      ],
      search: "",
      loading: false,
    };
  },
  computed: {
    districtAdmins() {
      return this.$store.state.optionsModule.districtAdmins || [];
    },
  },
  methods: {
    goToDistrictAdmin(item) {
      this.$router.push({
        name: "DistrictAdminForm",
        params: { districtAdminId: item.districtAdminId },
      });
    },
    goToNewDistrictAdmin() {
      this.$router.push({ name: "DistrictAdminForm" });
    },
  },
};
</script>

<style lang="css" scoped>
.alt-shading >>> tr:nth-child(even) {
  background: #ccc;
}
</style>